import request from '@/utils/request';

// 获取用户 => portlet
export async function qryPorletByUser(param) {
  return request(`/users/${param.userId}/portlets`);
}

// 获取用户 => portal => portlet
export async function qryPorletByPortal(param) {
  return request(`/users/${param.userId}/portal/${param.portalId}/portlets`);
}

// 获取types
export async function qryType() {
  return request('/portlets/types');
}

// 获取用户 => type => portlets
export async function qryPorletByType(param) {
  return request(`/users/${param.userId}/type/${param.typeId}/portlets`);
}
